/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeError = {
  code: string;
  details?: { [k: string]: any } | undefined;
  message: string;
  requestId: string;
};

/** @internal */
export const ComputeError$inboundSchema: z.ZodType<
  ComputeError,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  details: z.record(z.any()).optional(),
  message: z.string(),
  request_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "request_id": "requestId",
  });
});
/** @internal */
export type ComputeError$Outbound = {
  code: string;
  details?: { [k: string]: any } | undefined;
  message: string;
  request_id: string;
};

/** @internal */
export const ComputeError$outboundSchema: z.ZodType<
  ComputeError$Outbound,
  z.ZodTypeDef,
  ComputeError
> = z.object({
  code: z.string(),
  details: z.record(z.any()).optional(),
  message: z.string(),
  requestId: z.string(),
}).transform((v) => {
  return remap$(v, {
    requestId: "request_id",
  });
});

export function computeErrorToJSON(computeError: ComputeError): string {
  return JSON.stringify(ComputeError$outboundSchema.parse(computeError));
}
export function computeErrorFromJSON(
  jsonString: string,
): SafeParseResult<ComputeError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeError' from JSON`,
  );
}
